import { createSelector } from "@reduxjs/toolkit";
import { initialState, type UserDetailState } from "./slice";

const selectDomain = (state: {
  userDetail?: UserDetailState;
}): UserDetailState => state.userDetail || initialState;

export const selectProfile = createSelector(
  [selectDomain],
  (state) => state.profile,
);

export const selectProfilePic = createSelector(
  [selectDomain],
  (state) => state.profilePic,
);

export const selectChangePassword = createSelector(
  [selectDomain],
  (state) => state.changePassword,
);

export const selectEditProfile = createSelector(
  [selectDomain],
  (state) => state.editProfile,
);

export const selectEmailVerification = createSelector(
  [selectDomain],
  (state) => state.emailVerification,
);
